import "./Home.module.css";
import SiteHeader from "@/reusable_sections/Header";
import ExcellenceInMotion from "./sections/ExcellenceInMotion";
import ModernCareExceptionalComfort from "./sections/ModernCareExceptionalComfort";
import MeetDrAwaisAfridi from "./sections/MeetDrAwaisAfridi";
import OurClinicalExpertise from "./sections/OurClinicalExpertise";
import RealPatientExperiences from "./sections/RealPatientExperiences";
import ProfessionalEducation from "./sections/ProfessionalEducation";
import Collaborators from "./sections/Collaborators";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <SiteHeader />
      <ExcellenceInMotion />
      <ModernCareExceptionalComfort />
      <MeetDrAwaisAfridi />
      <OurClinicalExpertise />
      <RealPatientExperiences />
      <ProfessionalEducation />
      <Collaborators />
      <GetInTouch />
      <Footer />
    </div>;
}